import env from '../../config';

export const AuthSettingsApi = ['Restangular', (Restangular: Restangular.IService) => {
    return Restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(env.AUTH_API_URL);
    });
}]


// WEBPACK FOOTER //
// ./src/app/authsettings/services/authsettings.factory.ts